import React, { useCallback, useEffect, useRef } from "react";
import classnames from "classnames";

type NotificationProps = {
  type?: string;
  title?: React.ReactNode;
  message: React.ReactNode;
  timeOut?: number;
  onClick?: () => void;
  onRequestHide?: () => void;
  customClassName?: string;
};

function Notification({
  type = "info",
  title = null,
  message,
  timeOut = 5000,
  onClick = () => {},
  onRequestHide = () => {},
  customClassName = ""
}: NotificationProps) {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const requestHide = useCallback(() => {
    onRequestHide();
  }, [onRequestHide]);

  useEffect(() => {
    if (timeOut !== 0) {
      timerRef.current = setTimeout(requestHide, timeOut);
    }
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [requestHide, timeOut]);

  const handleClick = useCallback(() => {
    onClick();
    requestHide();
  }, [onClick, requestHide]);

  const className = classnames([
    "notification",
    `notification-${type}`,
    customClassName
  ]);
  const titleNode = title ? <h4 className="title">{title}</h4> : null;

  return (
    <div className={className} onClick={handleClick}>
      <div className="notification-message" role="alert">
        {titleNode}
        <div className="message">{message}</div>
      </div>
    </div>
  );
}

export default Notification;
